import { gql } from '@apollo/client';

export const PLAYER_STATS_FRAGMENT = gql`
  fragment PlayerStats on careerStats {
    id
    gamesPlayed
    goals
    assists
    pim
  }
`;
